// German
export const de = {
    weeklyRewards: 'Wöchentliche Belohnungen in',
    days: 'Tagen',
    hours: 'Stunden',
    minutes: 'Min',
    seconds: 'Sek',
    authenticating: 'Authentifizierung',
    verifyWallet: 'Bitte warten Sie, während wir Ihre Wallet überprüfen',
    authRequired: 'Authentifizierung erforderlich',
    authFailed: 'Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    points: 'Punkte',
    rank: 'Rang',
    of: 'von',
    players: 'Spielern',
    weeklyTopPlayers: 'Beste Spieler der Woche',
    thisWeekLeaderboard: 'Rangliste dieser Woche',
    rankingsReset: 'Rangliste wird jeden Sonntag um Mitternacht UTC zurückgesetzt',
    yourPoints: 'Ihre Punkte',
    dailyRewardAvailable: 'Tägliche Belohnung verfügbar!',
    nextClaimAvailable: 'Nächste Belohnung verfügbar in:',
    claimDailyReward: 'Tägliche Belohnung einfordern',
    claiming: 'Wird eingefordert...',
    multiplier: 'Multiplikator',
    bonusPointsMultiplier: 'Bonuspunkte-Multiplikator',
    outOf: 'von',
    loading: 'Wird geladen...',
    errorLoading: 'Fehler beim Laden',
    noEntries: 'Keine Einträge',
    leaderboard: 'Bestenliste',
    topPerformers: 'Beste Teilnehmer im ausgewählten Zeitraum',
    week: 'Woche',
    year: 'Jahr',
    tasks: 'Aufgaben',
    rules: 'Regeln',
    profile: 'Profil',
    comingSoon: 'Demnächst verfügbar...',
    completedTasks: 'Abgeschlossene\nAktivitäten',
    dailyRewardsClaimed: 'Eingeforderte tägliche Belohnungen',
    times: 'mal',
    recentActivity: 'Letzte Aktivität',
    noRewardsClaimed: 'Noch keine Belohnungen eingefordert',
    dailyReward: 'Tägliche Belohnung',
    howItWorks: 'So funktioniert es',
    welcomeMessage:
        'Willkommen bei Coinomi Rewards! Verdienen Sie Punkte durch das Abschließen verschiedener Aufgaben und steigen Sie in der Rangliste auf.',
    dailyRewardsTitle: 'Tägliche Belohnungen',
    dailyRewardsRules: [
        'Fordern Sie Ihre tägliche Belohnung alle 24 Stunden ein',
        'Jede Einforderung bringt 100 Punkte',
        'Punkte werden mit Ihrem Multiplikator multipliziert',
    ],
    multiplierBonusesTitle: 'Multiplikator-Boni',
    multiplierBonusesRules: [
        'Starten Sie mit 1x Multiplikator',
        'Verbinden Sie Telegram für +10% Bonus',
        'Bestätigen Sie Ihre E-Mail für +10% Bonus',
        'Boni stapeln sich für maximale Belohnungen',
    ],
    leaderboardTitle: 'Rangliste',
    leaderboardRules: [
        'Treten Sie gegen andere Spieler an',
        'Rangliste wird in Echtzeit aktualisiert',
        'Beste Spieler erhalten spezielle Belohnungen',
    ],
    boostEarningsTitle: 'Steigern Sie Ihre Verdienste',
    boostEarningsRules: [
        'Absolvieren Sie Herausforderungen für Boni',
        'Treten Sie unserer Telegram-Community bei',
        'Bleiben Sie aktiv für maximale Belohnungen',
    ],
    challenges: 'Herausforderungen',
    telegramChallenge: 'Telegram-Herausforderung',
    emailChallenge: 'E-Mail-Herausforderung',
    connectTelegram: 'Telegram verbinden',
    shareEmail: 'E-Mail teilen',
    telegramSuccess:
        '🎉 Glückwunsch! Sie erhalten jetzt einen permanenten 10% Bonus auf alle Belohnungen!',
    telegramPrompt:
        'Verbinden Sie Ihr Telegram-Konto für einen permanenten 10% Bonus auf alle Belohnungen!',
    emailSuccess:
        '🎉 Glückwunsch! Sie erhalten jetzt einen permanenten 10% Bonus auf alle Belohnungen!',
    emailPrompt: 'Teilen Sie Ihre E-Mail für einen permanenten 10% Bonus auf alle Belohnungen!',
    connectEmail: 'E-Mail verbinden',
    cancel: 'Abbrechen',
    emailPrivacy:
        'Wir verwenden Ihre E-Mail nur für wichtige Updates und Belohnungsbenachrichtigungen.',
    connectYourEmail: 'Verbinden Sie Ihre E-Mail',
    emailBonus:
        '🎉 Erhalten Sie einen permanenten 10% Bonus auf alle Belohnungen durch Verbinden Ihrer E-Mail!',
    enterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    emailAddress: 'E-Mail-Adresse',
    errorSavingEmail: 'Fehler beim Speichern der E-Mail. Bitte versuchen Sie es erneut.',
    claimButton: 'Einfordern',
    earnedReward: 'Verdiente Belohnung',
    rewardValue: '{{amount}} Punkte',
    claimingReward: 'Wird eingefordert...',
    claimSuccess: 'Erfolgreich {{amount}} Punkte eingefordert!',
    claimError: 'Einforderung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    privacyDisclaimer:
        'Coinomi sammelt keine persönlichen Daten; ein Drittsystem verwaltet sicher die Punkte und sozialen Verbindungen.',
    streakBonus: 'Streak-Bonus',
    streakDays: '{{days}}/5 Tage',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Extra',
    streakDescription: 'Fordere 5 Tage in Folge für maximalen Bonus',
    streakToday: 'Heute',
    streakMissed: 'Verpasst',
    streakComplete: 'Abgeschlossen',
    streakActive: 'Aktive Serie',
    streakLost: 'Serie verloren',
    streakNext: 'Nächste',
    home: 'Start',
    currentStreak: 'Aktuelle Serie',
    totalClaims: 'Gesamte Einforderungen',
    userStats: 'Ihre Statistiken',
    referrals: 'Empfehlungen',
    referralProgram: 'Empfehlungsprogramm',
    howReferralWorks: 'So funktionieren Empfehlungen:',
    referralSteps: [
        'Teilen Sie Ihren Empfehlungslink mit Freunden',
        'Wenn sie über Ihren Link beitreten, werden sie zu Ihren Empfohlenen',
        'Verdienen Sie Bonuspunkte für jede aktive Empfehlung',
        'Verfolgen Sie Ihre Empfehlungen und Verdienste hier',
    ],
    referralRewards: 'Empfehlungspunkte werden vergeben:',
    referralBonuses: [
        '100 Punkte pro Empfehlung',
        '10% aller Punkte, die Ihre Empfohlenen verdienen',
    ],
    yourReferralLink: 'Ihr Empfehlungslink',
    copyToClipboard: 'In Zwischenablage kopieren',
    linkCopied: 'Link in Zwischenablage kopiert!',
    totalReferrals: 'Gesamte Empfehlungen',
    yourReferralCode: 'Ihr Empfehlungscode',
    referralCodeCopied: 'Empfehlungscode kopiert!',
    editReferralCode: 'Empfehlungscode bearbeiten',
    editReferralCodeInstructions:
        'Wählen Sie einen neuen Empfehlungscode. Muss mindestens 5 Zeichen lang sein und kann Buchstaben und Zahlen enthalten.',
    newReferralCode: 'Neuer Empfehlungscode',
    referralCodeRequirements: 'Mindestens 5 Zeichen, nur Buchstaben und Zahlen',
    updating: 'Wird aktualisiert...',
    update: 'Aktualisieren',
    referralCodeTaken: 'Dieser Empfehlungscode ist bereits vergeben',
    haveReferralCode: 'Haben Sie einen Empfehlungscode?',
    enterReferralCodePrompt:
        'Wenn Sie jemand empfohlen hat, geben Sie hier deren Code ein, um die Konten zu verbinden.',
    enterReferralCode: 'Empfehlungscode eingeben',
    enterReferralCodeInstructions:
        'Geben Sie den Empfehlungscode ein, der mit Ihnen geteilt wurde.',
    referralCode: 'Empfehlungscode',
    referralCodeFormat: 'Nur Buchstaben und Zahlen',
    submitting: 'Wird gesendet...',
    submit: 'Senden',
    enterCode: 'Code eingeben',
    pleaseAddtoken: 'Bitte fügen Sie den Token-Parameter zur URL hinzu',
    authenticationError: 'Bei der Authentifizierung ist ein Fehler aufgetreten',
    noUserFound: 'Kein Benutzer gefunden',
    userNotFoundMessage: 'Benutzerdaten können nicht gefunden werden',
    backToHome: 'Zurück zum Start',
    retry: 'Erneut versuchen',
    baseMultiplier: 'Basis-Multiplikator',
    telegramBonus: 'Telegram-Bonus',
    referralChallenge: 'Empfehlungs-Herausforderung',
    referralChallengePrompt:
        'Laden Sie Freunde ein und verdienen Sie Bonuspunkte! Erhalten Sie 100 Punkte pro Empfehlung plus 10% ihrer Verdienste.',
    startReferring: 'Mit Empfehlungen beginnen',
    referralSuccess:
        '🎉 Glückwunsch! Sie haben erfolgreich Benutzer empfohlen und verdienen Bonuspunkte!',
    unranked: 'Nicht eingestuft',
    noPlayersYet: 'Seien Sie der Erste, der beitritt!',
    shareVia: 'Teilen über',
    shareOn: 'Auf {{network}} teilen',
    shareInviteText:
        '🚀 Ich verdiene kostenlose Kryptowährung mit @CoinomiWallet!\n\nLade Coinomi unter coinomi.com/downloads herunter und gib meinen Empfehlungscode {{referralCode}} ein, um einen Bonus zu erhalten, wenn du #Coinomi Rewards in der App beitrittst.',
    yourStatsThisWeek: 'Deine Statistiken diese Woche',
    pointsMultiplier: 'Punkte\nMultiplikator',
    yourRank: 'Dein\nRang',
    rewards: 'Belohnungen',
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    claimRewards: 'Belohnungen einfordern',
    pointsAvailable: 'Verfügbare Punkte',
    player: 'Spieler',
    score: 'Punkte',
    youHaveReferred_zero: 'Du hast noch keine Freunde eingeladen',
    youHaveReferred_one: 'Du hast einen Freund eingeladen',
    youHaveReferred_other: 'Du hast {{count}} Freunde eingeladen',
    referYourFriends: 'Freunde einladen',
    dailyRewardTooltip: 'Komm jeden Tag zurück, um deine Punkte & Belohnungen zu erhalten',
    weeklyRewardTooltip: 'Belohnungs-Airdrops werden wöchentlich verteilt',
    new_referral: 'Neue Empfehlung',
    daily_reward: 'Tägliche Belohnung',
    referral_bonus: 'Empfehlungsbonus',
    copy: 'Kopieren',
    // Twitter Challenge
    twitterChallenge: 'Twitter-Herausforderung',
    connectTwitter: 'Twitter verbinden',
    twitterSuccess:
        '🎉 Glückwunsch! Sie erhalten jetzt einen dauerhaften Bonus von 10% auf alle Belohnungen!',
    twitterPrompt:
        'Verbinden Sie Ihr Twitter-Konto, um einen dauerhaften Bonus von 10% auf alle Belohnungen zu erhalten!',
    pleaseAddUserId: 'Please add a userId parameter to the URL',
    emailChallengePrompt: 'Share your email to get a permanent 10% bonus on all rewards!',
    emailChallengeSuccess:
        '🎉 Connected! You are now receiving a permanent 10% bonus on all rewards!',
    followKoalaWalletChallenge: 'Follow @coinomiWallet on Twitter to support us!',
    twitterAuthSuccessTitle: 'Twitter Connected Successfully!',
    twitterAuthSuccessMessage:
        'You have successfully connected your Twitter account. You can now continue using the app.',
    continueToApp: 'Continue to App',
    twitter_like: 'Liked a tweet',
    twitter_retweet: 'Retweeted a tweet',
    disconnect: 'Trennen',
    followCoinomiWallet: 'Folge @coinomiWallet auf Twitter, um uns zu unterstützen!',
    connectedBonus:
        '🎉 Verbunden! Du erhältst jetzt einen dauerhaften 10% Bonus auf alle Belohnungen!',
};
